export const UsedBuilderTypesSymbol = Symbol('UsedBuilderTypes')

/**
 * SSR only: collects the builder types (components, context providers, function libraries) the rendered
 * page and masterPage use, so the server can report whether the page renders custom code.
 */
export type IUsedBuilderTypes = {
	add: (builderTypes: Iterable<string>) => void
	getAll: () => Array<string>
}
